import { z } from "zod";
import { tagsEnhancedSchema } from "./tagsSchema";

export const gvProductSchema = z.object({
  id: z.number(),
  sku: z.string(),
  amazon_category: z.string().nullable(),
  bsr_rank: z.number().nullable(),
  asin: z.string(),
  channel: z.enum(["AMZ", "walmart", "shopify"]),
  amazon_brand: z.string().nullable(),
  product_title: z.string(),
  product_description: z.string().nullable(),
  product_price: z.number(),
  product_quantity: z.number(),
  product_quantity_fba: z.number(),
  market_place: z.string(),
  product_image_url: z.string().nullable(),
  product_rating: z.number().nullable(),
  product_ratings_total: z.number().nullable(),
  tags: z.array(z.string()).nullable(),
  tags_enhanced: tagsEnhancedSchema,
  is_parent: z.boolean(),
  variations: z.record(z.string(), z.string()).nullable(),
  parent: z.number().nullable(),
  product_category: z.number(),
  stock_status: z.string().nullable(),
  merchandise_details: z.unknown(),
  landed_cost: z.number().nullable(),
  cogs: z.number().nullable(),
  margin: z.number().nullable(),
  shipping_cost: z.number().nullable(),
  inventory_state: z.string(),
  sales_state: z.string(),
  gross_price: z.number().nullable(),
  net_price: z.number().nullable(),
  eligibility_status: z.string().nullable(),
  fulfillment_channel: z.string(),
  created_on: z.string().datetime(),
  vine_program_enrolled: z.boolean(),
  search_rank: z.number(),
  org: z.number(),
  buy_box: z.boolean(),
  buy_box_reason: z.string().nullable(),
  fulfillment_fee: z.number().nullable(),
  channel_fees: z.number().nullable(),
  parent_asin: z.string().nullable(),
  additional_prices: z.object({}).nullable(),
});

export type GVProduct = z.infer<typeof gvProductSchema>;
